import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    editMidSession: [],
    loading: false,
    error: null,
}

const editMidSessionSlice = createSlice({
    name: "editMidSession",
    initialState,
    reducers: {
        fetcheditMidSessionSuccess: (state, action) => {
            state.loading = false,
            state.editMidSession = action.payload;
        },
        fetcheditMidSessionFailure: (state, action) => {
            state.loading = false,
            state.error = action.payload;
        },
    },
})

export const {
    fetcheditMidSessionSuccess,
    fetcheditMidSessionFailure,
} = editMidSessionSlice.actions;

export default editMidSessionSlice.reducer;